<template>
  <div
    :dependentComputedProps="{
      isSessionPresent,
    }"
  >
    <div v-if="welcomeOffers.length && !showShimmer">
      <div class="plr16">
        <span class="fs-16 tc fw-700 color-slaty-dark">{{ title }}</span>
        <lazy-image alt="default image" :src="titleImg" class="pl5" />
      </div>
      <div class="payment-offer-wrap pt12 mb24 low-gap">
        <div class="custom-offer-carousel w-container pr8">
          <Carousel
            :pauseAutoplayOnHover="true"
            :transition="500"
            :touchDrag="false"
            :mouseDrag="false"
            :settings="settings"
            :breakpoints="breakpoints"
          >
            <Slide
              :class="welcomeOffers.length > 1 ? 'pr12' : 'full-width-card'"
              v-for="(item, index) in welcomeOffers"
              :key="item?.id"
            >
              <offer-card
                :data-index="index"
                :data-title="item.metaData.name"
                :data-promo-code="item.couponCode"
                :data-description="item.metaData.description"
                :data-display-message="item.metaData?.shortSavingsMessage"
                :data-action="
                  appliedOfferPromo == item.couponCode ? 'Remove' : 'Apply'
                "
                :data-text="item.metaData?.description"
                :data-item-tnc="item.campaignId"
                :data-discount="discount"
                :data-is-applicable="item?.applicable"
                :data-offer-icon="getOfferIcon(item, index)"
                :data-offer-background-top="getOfferBackgroundTop(item, index)"
                :data-offer-background-bottom="
                  getOfferBackgroundBottom(item, index)
                "
                :data-theme="getTheme(item, index)"
                :data-expiry-timer="item?.expiryTimer"
                :data-bottom-msg="getBottomMsg(item)"
                :data-from-home="true"
              ></offer-card>
              <view-all-offer-card
                v-if="index === welcomeOffers.length - 1"
                :data-view-all-image="viewAllOfferPercent"
                :data-view-all-text="viewAllText"
                :data-view-all-bg="viewAllBg"
              ></view-all-offer-card>
            </Slide>
            <template #addons v-if="clientPlatform == 'Web'">
              <Navigation />
            </template>
          </Carousel>
        </div>
      </div>

      <!-- offer details popup -->
      <offer-details-popup
        v-if="offerDetailsModalFlag"
        :data-title="welcomeOffers[selectedOfferIndex]?.metaData?.name"
        :data-description="
          welcomeOffers[selectedOfferIndex]?.metaData?.description
        "
        :data-coupon-code="welcomeOffers[selectedOfferIndex]?.couponCode"
        :data-expiry-date="welcomeOffers[selectedOfferIndex]?.expiryDate"
        :data-savings-msg="
          welcomeOffers[selectedOfferIndex]?.metaData?.savingsMessage
        "
        :data-theme="
          getTheme(welcomeOffers[selectedOfferIndex], selectedOfferIndex)
        "
        :data-is-applicable="welcomeOffers[selectedOfferIndex]?.applicable"
      ></offer-details-popup>

      <!-- offer applied popup --- when card is not selected-->
      <generic-modal
        v-if="showOfferAppliedModal"
        @close="closeAppliedModal()"
        :height="'auto'"
        :width="'80vw'"
        :padding="'0px'"
        :borderRadius="'8px'"
        :background="`url(${offerAppliedBackground}), #FFFFFF`"
        :backgroundRepeat="'no-repeat'"
        :backgroundSize="`100% auto`"
        class="d-flex justify-content-center align-items-center plr40"
        :class="[
          clientPlatform == 'Web'
            ? 'lg-screen-centered sticky-bottom show overflow-y'
            : '',
        ]"
      >
        <template v-slot:header>
          <!-- <div class="handle-wrap positionselectediconhomepage">
            <img
              :src="staticImgBaseUrl + '/images/global/offerSelectedIcon.svg'"
              class="offerselectedicon"
            />
          </div> -->
        </template>
        <template v-slot:body>
          <div
            class="full-screen-popup offer-confetti"
            v-if="showLottie"
            :style="{
              background: `url(${tickLottieBg})`,
              backgroundRepeat: 'no-repeat',
            }"
          >
            <VueLottiePlayer
              name="confettiAnim"
              :width="clientPlatform == 'Web' ? '18%' : '38%'"
              :height="clientPlatform == 'Web' ? '18%' : '38%'"
              :animationData="require('../assets/tickLottie.json')"
            />
          </div>
          <div class="ms-offer-pop-content">
            <offer-selected-popup
              :data-title="`'${appliedOfferPromo}' ${offerPopupHeaderText}`"
              :data-description="getDataDescription"
              :data-action="'Woohoo! Thanks'"
              :data-padding-left="clientPlatform == 'Web' ? '16vw' : '30vw'"
            ></offer-selected-popup>
          </div>
        </template>
        <template v-slot:footer>
          <div></div>
        </template>
      </generic-modal>
    </div>
    <offers-home-shimmer v-else-if="showShimmer"></offers-home-shimmer>
  </div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>

<script>
import { Carousel, Slide, Navigation } from "vue3-carousel";
import { defineAsyncComponent } from "vue";
import Utility from "../helpers/utility";
import {
  imgBaseUrl,
  staticImgBaseUrl,
  clientPlatform,
} from "../config/apiEndpoints";
import {
  keyMapsAction,
  keyMapsMutation,
  keyMapsGetter,
} from "../helpers/storeKeys";
import OfferCard from "./OfferCard.vue";
import ViewAllOfferCard from "./ViewAllOfferCard.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import OffersHomeShimmer from "./OffersHomeShimmer.vue";
import OfferDetailsPopup from "./OfferDetailsPopup.vue";
import { EVENT_CLICK_APPLYOFFERSUCCESS } from "../helpers/analyticsEvents";
import "vue3-carousel/dist/carousel.css";

export default {
  name: "Offers",
  components: {
    Carousel,
    Slide,
    Navigation,
    OfferDetailsPopup,
    OfferCard,
    ViewAllOfferCard,
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
    OffersHomeShimmer,
  },
  props: ["dataResults", "moduleProps"],
  data() {
    return {
      offerlist: [
        "On the application of the deal code WELCOME120, discount will automatically be deducted from the booking amount.",
        "On the application of the deal code LAH50, discount will automatically be ",
      ],
      offerlistModal: {
        width: "100vw",
        height: "100%",
        modalClass: "full-screen-popup",
      },
      staticImgBaseUrl: staticImgBaseUrl,
      imgBaseUrl: imgBaseUrl,
      sessionDependedMethodsProcessed: false,
      clientPlatform,
      showLottie: true,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        700: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        1024: {
          itemsToShow: "auto",
          snapAlign: "start",
        },
      },
      modulePropsData: {},
      title: "Offers",
      titleImg: "",
      viewAllCta: "View All",
      offerBackgrounds: {},
      offersCountHome: 5,
      viewAllOfferPercent: "",
      viewAllText: "",
      viewAllBg: "",
      showShimmer: true,
      offerPopupHeaderText: "",
      offerAppliedBackground: "",
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    this.title = this.modulePropsData?.title;
    this.titleImg = this.modulePropsData?.titleImg;
    this.viewAllCta = this.modulePropsData?.viewAllCta;
    this.viewAllOfferPercent = this.modulePropsData?.viewAllOfferPercent;
    this.viewAllText = this.modulePropsData?.viewAllText;
    this.viewAllBg = this.modulePropsData?.viewAllBg;
    this.offerBackgrounds = Utility.tryJsonParse(
      this.modulePropsData?.offerBackgrounds,
    );
    this.offerPopupHeaderText = this.modulePropsData?.offerPopupHeaderText;
    this.offersCountHome = this.modulePropsData?.offersCountHome;
    this.offerAppliedBackground = this.modulePropsData?.offerAppliedBackground;
    LocalStorageFunc.setPrevUrl(window.location.href);
    this.$store.commit(
      keyMapsMutation.UPDATE_OFFER_APPLY_MODAL,
      JSON.parse(LocalStorageFunc.getOfferAppliedModal()),
    );
    setTimeout(this.closeAppliedModal, 3000);

    this.$store.commit(
      keyMapsMutation.UPDATE_APPLIED_COUPON_PROMO,
      LocalStorageFunc.getCouponCode()?.code,
    );
  },
  updated() {
    if (JSON.parse(LocalStorageFunc.getOfferAppliedModal())) {
      this.$store.commit(
        keyMapsMutation.UPDATE_OFFER_APPLY_MODAL,
        JSON.parse(LocalStorageFunc.getOfferAppliedModal()),
      );
      setTimeout(this.closeAppliedModal, 3000);

      this.$store.commit(
        keyMapsMutation.UPDATE_APPLIED_COUPON_PROMO,
        LocalStorageFunc.getCouponCode()?.code,
      );
    }
  },
  methods: {
    triggerOfferListing() {
      Utility.sendToOffersScreen();
    },
    closeAppliedModal(event) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL, false);
      this.$store.commit(
        keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG,
        false,
      );
    },
    getOfferIcon(item, index) {
      if (!item?.applicable) {
        return this.modulePropsData?.disabledOfferIcon;
      } else if (!item?.expiryTimer?.endTime) {
        return this.offerBackgrounds?.[
          index % this.modulePropsData?.couponCount
        ]?.iconPercent;
      } else {
        return this.offerBackgrounds?.[
          index % this.modulePropsData?.couponCount
        ]?.icon;
      }
    },
    getOfferBackgroundTop(item, index) {
      if (!item?.applicable) {
        return this.modulePropsData?.disabledOfferBackgroundTop;
      } else {
        return this.offerBackgrounds?.[
          index % this.modulePropsData?.couponCount
        ]?.backgroundTop;
      }
    },
    getOfferBackgroundBottom(item, index) {
      if (!item?.applicable) {
        return this.modulePropsData?.disabledOfferBackgroundBottom;
      } else {
        return this.offerBackgrounds?.[
          index % this.modulePropsData?.couponCount
        ]?.backgroundBottom;
      }
    },
    getTheme(item, index) {
      if (!item?.applicable) {
        return "";
      } else {
        return this.offerBackgrounds?.[
          index % this.modulePropsData?.couponCount
        ]?.index;
      }
    },
    getBottomMsg(offersData) {
      // Check if offer is applicable
      if (offersData.applicable) {
        // Check if there's an expiry timer
        if (
          offersData.expiryTimer &&
          offersData.expiryTimer.endTime !== 0 &&
          offersData.expiryTimer.endTime > Date.now() &&
          offersData.expiryTimer.showTimerBefore <= Date.now()
        ) {
          if (
            offersData.labelType &&
            offersData.labelType === "General_Milestone" &&
            offersData.offerOptions
          ) {
            // MilestoneCouponBar logic
            return ""; //Todo
          } else {
            return `Coupon expires in
              ${Utility.formatTimestampOffer(
                offersData.expiryTimer?.endTime - Date.now(),
              )}`;
          }
        }

        // General Milestone without expiryTimer
        if (
          offersData.labelType &&
          offersData.labelType === "General_Milestone" &&
          offersData.offerOptions
        ) {
          return ""; //Todo
        }

        // Payment offer with message
        if (
          offersData.paymentOffersMetadata?.paymentId &&
          offersData.messages &&
          offersData.messages[0]?.messageType &&
          offersData.messages[0]?.messageType.toLowerCase() === "nudge" &&
          offersData.messages[0]?.message
        ) {
          return offersData.messages[0].message;
        }
      } else if (
        !offersData.applicable &&
        offersData.messages &&
        offersData.messages[0]?.messageType &&
        offersData.messages[0]?.messageType.toLowerCase() === "error" &&
        offersData.messages[0]?.message
      ) {
        return offersData.messages[0].message;
      }

      return this.modulePropsData?.staticOfferCardText; // Fallback case
    },
  },
  computed: {
    welcomeOffers() {
      let offers = this.$store.state.Offers.offersList.slice(
        0,
        this.offersCountHome,
      );
      if (offers.length) {
        setTimeout(() => (this.showShimmer = false), 1000);
      } else {
        setTimeout(() => (this.showShimmer = false), 4000);
      }
      return offers;
    },
    appliedOfferPromo() {
      return this.$store.state.Offers.appliedOfferPromo;
    },
    offerDetailsModalFlag() {
      return this.$store.state.Offers.offerDetailsModalFlag;
    },
    selectedOfferIndex() {
      return this.$store.state.Offers.selectedOfferIndex;
    },
    selectedOfferTnc() {
      return this.$store.state.Offers.selectedOfferTnc;
    },
    isViewAllSelected() {
      return this.$store.state.Offers.isViewAllOffersSelected;
    },
    showOfferAppliedModal() {
      setTimeout(() => LocalStorageFunc.setOfferAppliedModal(false), 3000);
      let isOfferAppliedModal = this.$store.state.Offers.isOfferAppliedModal;
      if (isOfferAppliedModal) {
        EVENT_CLICK_APPLYOFFERSUCCESS({
          subCategory: "popup shown",
          sectionPosition: 1,
          positionWithinSection:
            this.$store.state.Offers.selectedOfferIndex + 1,
          category: this.$store.state.Offers.appliedOfferPromo,
          cartValue: this.$store.getters[keyMapsGetter.CART_TOTAL],
          couponCode: this.$store.state.Offers.appliedOfferPromo,
          couponIndex: this.$store.state.Offers.selectedOfferIndex + 1,
        });
      }
      if (isOfferAppliedModal) {
        this.showLottie = true;
      }
      return isOfferAppliedModal;
    },
    getDataDescription() {
      return this.welcomeOffers.find(
        (x) => x.couponCode === this.appliedOfferPromo,
      )?.metaData?.savingsMessage;
    },
    discount() {
      return this.$store.state.Offers.discount;
    },
    tickLottieBg() {
      const theme =
        this.$store.state.Offers.selectedOfferTheme ||
        LocalStorageFunc.getOfferTheme() ||
        "#911987";
      return JSON.parse(this.modulePropsData?.tickLottieBg)[theme];
    },
    isSessionPresent() {
      let isSessionP = this.$store.state.Auth.isSessionPresent;
      if (isSessionP && !this.sessionDependedMethodsProcessed) {
        this.$store.dispatch(keyMapsAction.WELCOME_OFFER_API, "HOME_V3");
        // this.$store.dispatch(keyMapsAction.PAYMENT_OFFER_API, {});
        this.sessionDependedMethodsProcessed = true;
      }
      return isSessionP;
    },
  },
};
</script>

<style></style>
